import * as Sentry from "@sentry/react";
import { shouldDropKnownNoiseEvent } from "./filters";

let isInitialized = false;

const initSentry = () => {
  if (!isInitialized) {
    Sentry.init({
      dsn: "https://c5b44dbbb8b74a8886de4e2a8de01c5f@o636155.ingest.sentry.io/5755934",
      enableInExpoDevelopment: true,
      debug: process.env.NODE_ENV === "development",
      normalizeDepth: 7,
      maxBreadcrumbs: 50,
      attachStacktrace: true,
      tracesSampleRate: process.env.NODE_ENV === "development" ? 1.0 : 0.1,
      beforeSend(event, hint) {
        if (shouldDropKnownNoiseEvent(event, hint)) {
          return null;
        }

        if (event.exception) {
          const error = hint?.originalException;
          if (
            error?.isUserRecoverable &&
            error.message?.startsWith("Could not load data.")
          ) {
            return null;
          }
          if (error) {
            event.extra = {
              ...event.extra,
              errorName: error.name,
              errorMessage: error.message,
              errorStack: error.stack,
              userAgent:
                typeof navigator !== "undefined"
                  ? navigator.userAgent
                  : undefined,
              url:
                typeof window !== "undefined"
                  ? window.location?.href
                  : undefined,
            };
          }
        }
        return event;
      },
    });

    Sentry.withScope((scope) => {
      scope.setTag("platform", "web");
    });

    isInitialized = true;
  }
  return Sentry;
};

// Initialize Sentry synchronously
initSentry();

// Export Sentry directly with initialization check
const sentryProxy = {
  init: initSentry,
  setUser: (...args) => Sentry.setUser(...args),
  captureException: (...args) => Sentry.captureException(...args),
  captureMessage: (...args) => Sentry.captureMessage(...args),
  withScope: (...args) => Sentry.withScope(...args),
  addBreadcrumb: (...args) => Sentry.addBreadcrumb(...args),
  setTag: (...args) => Sentry.setTag(...args),
  setContext: (...args) => Sentry.setContext(...args),
  // Add any other Sentry methods you need here
};

export default sentryProxy;
